import mirrorCreator from 'mirror-creator';

export default mirrorCreator([
  'SHOW_APP_FATAL_ERROR',
  'HIDE_APP_FATAL_ERROR',
  'SHOW_APP_INFO',
  'HIDE_APP_INFO',
]);



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/constants/appConstants.js